import { Button, Stack, TableCell, TableRow } from "@mui/material";
import type { EmailAccountInfo, SmtpLoginStatus } from "../../../api/emailAccountsTypes";
import EmailAccountCells from "./EmailAccountCells";

interface Props {
  account: EmailAccountInfo;
  smtpLoginStatus?: SmtpLoginStatus;
  defaultForClientTitles: string[];
  getClientTitle: (clientCode: string) => string;
  onSelectClient: (clientCode: string) => void;
  onSendTestEmail?: (account: EmailAccountInfo) => void;
}

const OrganizationEmailAccountRow = ({
  account,
  smtpLoginStatus,
  defaultForClientTitles,
  getClientTitle,
  onSelectClient,
  onSendTestEmail,
}: Props) => (
  <TableRow>
    <EmailAccountCells account={account} smtpLoginStatus={smtpLoginStatus} />
    <TableCell>
      <Stack direction="row" sx={{ flexWrap: "wrap", gap: 1 }}>
        {account.clients.map(({ clientCode }) => (
          <Button key={clientCode} variant="outlined" onClick={() => onSelectClient(clientCode)}>
            {getClientTitle(clientCode)}
          </Button>
        ))}
      </Stack>
    </TableCell>
    <TableCell>{defaultForClientTitles.join(", ")}</TableCell>
    {onSendTestEmail && (
      <TableCell>
        <Button variant="outlined" disabled={account.clients.length === 0} onClick={() => onSendTestEmail(account)}>
          Send test email
        </Button>
      </TableCell>
    )}
  </TableRow>
);

export default OrganizationEmailAccountRow;
